import { Action, createReducer, on } from '@ngrx/store';
import {
  addMessage,
  removeMessage,
  removeMessagesByType,
} from '../actions/global-message.actions';
import { GlobalMessageEntities } from '@boels/models';

export interface GlobalMessageState {
  entities: GlobalMessageEntities;
}
export const initialState: GlobalMessageState = {
  entities: {},
};

const globalMessagesReducer = createReducer(
  initialState,
  on(addMessage, (state: GlobalMessageState, { message }) => {
    if (state.entities[message.type] === undefined) {
      return {
        ...state,
        entities: {
          ...state.entities,
          [message.type]: [message.text],
        },
      };
    } else {
      const currentMessages: string[] = state.entities[message.type];
      return {
        ...state,
        entities: {
          ...state.entities,
          [message.type]: [...currentMessages, message.text],
        },
      };
    }
  }),

  on(removeMessage, (state: GlobalMessageState, { messageType, index }) => {
    if (
      Object.keys(state.entities).length === 0 ||
      !state.entities[messageType]
    ) {
      return state;
    }

    const messages = [...state.entities[messageType]];
    messages.splice(index, 1);

    return {
      ...state,
      entities: {
        ...state.entities,
        [messageType]: messages,
      },
    };
  }),

  on(removeMessagesByType, (state: GlobalMessageState, { messageType }) => {
    const entities = {
      ...state.entities,
      [messageType]: [],
    };
    return {
      ...state,
      entities,
    };
  }),
);

export function reducer(state: GlobalMessageState | undefined, action: Action) {
  return globalMessagesReducer(state, action);
}
